export const Env = {
    basePageTitle: `${process.env.REACT_APP_BASE_PAGE_TITLE}`,
    allowDebugger: `${process.env.REACT_APP_ALLOW_DEBUGGER}` === 'true',
    helpUrl: `${process.env.REACT_APP_HELP_URL}`
};